import React from 'react';
import PostManagementComponent from '../../../components/admin/community/PostManagementComponent';

const PostManagement: React.FC = () => {
  return <PostManagementComponent />;
};

export default PostManagement;
